import { Dimmer, Loader, Segment } from "semantic-ui-react";

export default function CheckingCredentials() {
  const text = "Comprobando tus credenciales...";

  return (
    <Segment style={{ height: "100vh" }}>
      <Dimmer active>
        <Loader>{text}</Loader>
      </Dimmer>
    </Segment>
  );
}
